module.exports = __webpack_public_path__ + "img/0B.35949c54.png";